export const getCssVar = (name, dom = document.documentElement) => {
	return getComputedStyle(dom).getPropertyValue(`--${name}`).trim()
}
